export const Vehicle_Number_Not_Mandatory = [
    'No Vehicle',
    'Cycle',
    'Rental EV',
];
